var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 87 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2166 15.2854H30.7374L42.4491 0H29.9291L18.2166 15.2854Z",
    fill: "#1E0039"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1182 0H55.3667L43.6559 15.2854H55.4088L67.1182 0Z",
    fill: "#1E0039"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.008 0H2.32173C1.03977 0 0 1.04062 0 2.32172V12.9628C0 14.2448 1.04062 15.2845 2.32173 15.2845H5.29629L17.008 0Z",
    fill: "#1E0039"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7822 0H80.0368L68.326 15.2854H83.7824C85.0644 15.2854 86.1041 14.2448 86.1041 12.9636V2.32256C86.1041 1.03898 85.0649 0 83.7822 0Z",
    fill: "#1E0039"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6563 25.3711C33.0784 25.3711 24.4715 33.9788 24.4715 44.5584C24.4715 55.1379 33.0792 63.7448 43.6563 63.7448C54.2358 63.7448 62.8435 55.1387 62.8435 44.5584C62.8443 33.9788 54.2343 25.3711 43.6563 25.3711ZM46.4857 59.0163V43.223L51.0344 47.7717C51.4247 48.1621 52.0572 48.1621 52.45 47.7717L54.9531 45.2661C55.3459 44.8758 55.3459 44.2433 54.9531 43.853L47.5764 36.4763L44.3655 33.2604C43.9752 32.8725 43.3403 32.8725 42.9499 33.2604L32.3574 43.853C31.967 44.2433 31.967 44.8782 32.3574 45.2661L34.863 47.7717C35.2533 48.1621 35.8858 48.1621 36.2785 47.7717L40.825 43.2253V59.0178C34.0499 57.6945 28.918 51.718 28.918 44.5592C28.918 36.4349 35.527 29.8203 43.6544 29.8203C51.781 29.8203 58.3908 36.4341 58.3908 44.5592C58.3924 51.7163 53.2639 57.6922 46.4855 59.0161L46.4857 59.0163Z",
    fill: "#1E0039"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7822 16.4482H2.32173C1.03977 16.4482 0 17.4889 0 18.77V70.6258C0 71.9077 1.04062 72.9475 2.32173 72.9475H83.7822C85.0642 72.9475 86.1039 71.9069 86.1039 70.6258L86.1047 18.77C86.1031 17.4872 85.0641 16.4482 83.7814 16.4482H83.7822ZM43.6563 67.3546C31.0644 67.3546 20.8599 57.1484 20.8599 44.5581C20.8599 31.9685 31.0637 21.7617 43.6563 21.7617C56.2459 21.7617 66.4527 31.9679 66.4527 44.5581C66.4519 57.1492 56.2457 67.3546 43.6563 67.3546Z",
    fill: "#1E0039"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.9696b028b0824276e121999b81343583.svg";
export { ForwardRef as ReactComponent };